<ion-header class="app-safe-area-header bg-gray-300">    
  <div class="relative grid grid-cols-[auto_1fr_auto] items-center p-4">
    <lib-icon name="cancel" class="text-2xl cursor-pointer"
    (click)="closeModal()"></lib-icon>
    <h2 class="absolute inset-0 flex items-center justify-center text-lg font-semibold font-title pointer-events-none px-12 truncate">
      Acciones manuales
    </h2>
  </div>
</ion-header>
<ion-content>
  <div
      class="app-safe-area-fill bg-gray-300 flex flex-col justify-between w-full h-full p-4 overflow-x-hidden overflow-y-auto dark:bg-gray-900 lg:p-10"
    >
    
    <div class="rounded-2xl bg-white">
      <div class="rounded-t-2xl px-6 py-5 border border-gray-200 text-gray-800 font-medium font-title text-theme-md">
        {{title()}}
      </div>
      
      <div class="p-4 flex flex-col gap gap-4 bg-gray-100 rounded-b-2xl border border-gray-200">
        <div class="flex flex-col items-center rounded-2xl border border-gray-200 bg-white font-title px-5 py-4">
          <div class="text-theme-sm text-gray-500">
            Modo
          </div>
          <div class="text-theme-lg text-gray-950 font-semibold">
            {{modeText()}}
          </div>
        </div>
        @if (hasPermission()) {
          <div class="text-theme-sm text-gray-500 flex justify-center font-title">Cambiar a</div>
          <div class="flex justify-center gap-3">
            @if(showManualStop()) {
              <lib-button size="sm" (btnClick)="sendAction('MANUAL_STOP')" [disabled]="manualStopDisabled">
                Manual paro
              </lib-button>
            }
    
            @if(showManualStart()) {
              <lib-button size="sm" (btnClick)="sendAction('MANUAL_START')" [disabled]="manualStartDisabled">
                Manual marcha
              </lib-button>
            }
    
            @if(showAutomatic()) {
              <lib-button size="sm" (btnClick)="sendAction('AUTO')" [disabled]="automaticDisabled">
                Automático
              </lib-button>
            }
          </div>
        } @else {
          <div class="flex justify-center gap-3">
            <div class="text-theme-sm text-gray-500 flex justify-center">
              {{showNoPermissionMessage()}}
            </div>
          </div>
        }
      </div>
    </div>
    
  </div>
</ion-content>
